// extracted by mini-css-extract-plugin
var _1 = "DocumentUploadDestinationModal-moduleradioGroup__knJjD RadioGroup-moduleRadioGroup__JpFJJ";
export { _1 as "radioGroup" }
